import { FC, useMemo } from 'react';

import { BadgeVariant } from '@purpur/library';

import { StyledMenuItemBadge } from './MenuItemBadge.styles';

interface Props {
    className?: string;
    children: string;
}

const INFORMATION_BADGES = ['Nauja', 'Tik telia.lt'];

export const MenuItemBadge: FC<Props> = ({ className, children }) => {
    const variant = useMemo((): BadgeVariant => {
        if (INFORMATION_BADGES.includes(children)) {
            return 'information';
        }

        return 'attention';
    }, [children]);

    return (
        <StyledMenuItemBadge variant={variant} showIcon={false} className={className}>
            {children}
        </StyledMenuItemBadge>
    );
};
